import { getTextUre } from 'Domain/Mesh/Provider/TextProvider'
import { Vector3, Box3, BufferGeometry, Line } from 'three'

const _tempVector3 = new Vector3();
const _tempBox3 = new Box3();

/*****************************************************************
 * Markup Handler
 * ***************************************************************/

/**
 * Retrieve Marker
 * @param {string} text 
 * @param {string} name 
 * @returns object
 */
export const getMarkup = ( text, name ) => getTextUre( text, name )

/**
 * Assign Marker Position 
 * @param {object} marker 
 * @param {array} subject 
 * @param {object} center 
 * @param {string} arch 
 */
export const assignMarkupPosition = ( marker, subject, center, arch, archesCount ) => {

    let pivot,
        decay = (archesCount > 1)?
            (arch === 'maxi')? 22 : 5:
            (arch === 'maxi')? -5 : 5

    if( subject )
        pivot = {
            x: subject[0] ? subject[0] : 0,
            y: subject[1] ? subject[1] : 0,
            z: subject[2] ? subject[2] : 0
        }

    let
        delay = {
            x: pivot.x - center.x,
            y: pivot.y - center.y - 15,
            z: pivot.z - center.z
        },
        dist = Math.sqrt((delay.y*delay.y) + (delay.x*delay.x)),
        ratio = 7/dist

    marker.position.set(
        pivot.x + ratio*(delay.x), 
        pivot.y + ratio*(delay.y), 
        decay
    )
}

/**
 * Provide Line for specified Markup
 * @param {object} marker 
 * @param {array} iprCoords 
 * @returns 
 */
export const getMarkupAttachment = ( marker, iprCoords ) => {
    _tempBox3.setFromObject(marker);
    _tempBox3.getCenter(_tempVector3);
    const startPoint = _tempVector3.clone();
    const endPoint = new Vector3(iprCoords[0], iprCoords[1], iprCoords[2]);
    
    const geometry = new BufferGeometry().setFromPoints([startPoint, endPoint]);
    geometry.verticesNeedUpdate = true;

    let mesh = new Line(geometry);
    mesh.name = 'MarkerLine-'+marker.name;

    return mesh;
}

/**
 * 
 * @param {object} marker 
 * @param {object} attachment 
 * @param {object} line 
 */
export const updateMarkupAttachmentPosition = ( marker, attachment, line ) => {
    _tempBox3.setFromObject(attachment);
    const attcenter = _tempBox3.getCenter(_tempVector3.clone());
    
    _tempBox3.setFromObject(marker);
    const markercenter = _tempBox3.getCenter(_tempVector3.clone());

    line.geometry.setFromPoints([markercenter, attcenter]);
}